import { render } from "./PatientAddress.vue?vue&type=template&id=5021a7e4"
import script from "./PatientAddress.vue?vue&type=script&lang=js"
export * from "./PatientAddress.vue?vue&type=script&lang=js"

import "./PatientAddress.vue?vue&type=style&index=0&id=5021a7e4&lang=css"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__